const getFormData = $form => {
    const data = {};
    $.map($form.serializeArray(), o => {
        data[o.name] = data[o.name] ? (data[o.name] + ',' + o.value) : o.value;
    });
    return data;
};

const getUrlData = fromHash => {
    const data = {};
    let search = fromHash ? location.hash.replace('#', '') : location.search.replace('?', '');
    search.indexOf('&') > -1 && (search = search.split('&'));
    !Array.isArray(search) && (search = [search]);
    if ( search.length === 1 && search[0] === '' ) {
        return data;
    }
    $.map(search, param => data[decodeURIComponent(param.split('=')[0])] = decodeURIComponent(param.split('=')[1]));
    return data;
};

const setFormData = (form, data) => {

    $.map(data, (val, name) => {
        const elem = form[name];

        if ( !elem ) {
            return;
        }

        let $elem = $(elem);
        const date = $elem.closest('.datepicker, .datepicker-range')[0];
        if ( date && $elem.attr('name') == 'dates' ) {
            let dates = val ? val.split(' - ') : [];
            if ( dates[0] && dates[1] ) {
                date._flatpickr.setDate([dates[0],dates[1]]);
            } else if(dates[0]) {
                date._flatpickr.setDate([dates[0],dates[0]]);
            } else {
                date._flatpickr.setDate(null);
            }
        }
        else if ( elem.type === 'checkbox' ) {
            elem.checked = !!val;
        }
        else if ( elem[0] && elem[0].type === 'checkbox' ) {
            val = $.isArray(val) ? val : (val || '').split(',');
            elem.forEach(elem => {
                elem.checked = val.indexOf(elem.value) > -1;
            });
        }
        else if ( elem.noUiSlider ) {
            // val = $.isArray(val) ? val : (val || '').split(',').map(v => +v);
            // elem.noUiSlider.set(val);
            elem.value = val;
        }
        else {
            $(elem).val(val);
        }
        $(elem).trigger('change');
    });
};

let setUrlTimeout = 0;
const setUrlData = (data, toHash, replace, defaults) => {
	clearTimeout(setUrlTimeout);
	setUrlTimeout = setTimeout(() => {
		$.map(data, (value, key) => (!value || (defaults && defaults[key] == value)) && (delete data[key]));
		if ( toHash ) {
			let newHash = $.param(data);
			let oldHash = location.hash.replace('#', '');
			if ( newHash !== oldHash ) {
				if ( replace ) {
					history.replaceState('', '', '#' + newHash);
				} else {
					location.hash = newHash;
				}
			}
		} else {
			location.search = $.param(data);
		}
	}, 100);
};

const getLang = () => {
    let lang = (document.documentElement.lang || '').split('-')[0] || 'hr'
    return lang == 'cs' ? 'cz' : lang ;
};

const scrollToElement = ($elem, offset) => {
    $elem = $($elem);
    $elem.length && $('html, body').animate({
        scrollTop: $elem.offset().top - (offset || 0)
    });
};

const setCookie = (key, value) => {
    let expires = new Date();
    expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + '; path=/';
};

const getCookie = (key) => {
    let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
};

const initCompare = () => {
    const favorites = JSON.parse(getCookie("favorites")) || [];

    $("[data-compare-add]").on('click', function (e) {
        e.preventDefault();
        console.log(e);
        let id = $(this).attr('data-compare-add'), elementTitle = '';

        if ( $(this).find('.las.la-heart:not(.active)').length ) {
            favorites.push(id);
            $(this).find('.las.la-heart').addClass('active');
        } else {
            delete favorites.splice(favorites.indexOf(id), 1);
            $(this).find('.las.la-heart').removeClass('active');

            if ($(".compare-list").length) {
                location.reload();
            }
        }

        setCookie("favorites", JSON.stringify(favorites));

    });

    $( "*[data-compare-add]" ).each(function() {

        if( $.inArray($(this).attr('data-compare-add'), favorites ) > -1 ) {
            $(this).find('.las.la-heart').addClass('active');
        } else {
            $(this).find('.las.la-heart').removeClass('active');
        }
    });
};

const isObject = obj => {
    return obj === Object(obj);
}

const smallWin = () => {
    return window.innerWidth < 992;
}

const isMobile = () => {
    // if ( isMobileDevice() ) {
    //     return true;
    // }
    if ( smallWin() ) {
        return true;
    }
    return false;
};

const swipeTreshold = 40; // min difference to consider action as swiping
let swipeTimeout = 0;
let swipeStartX = 0;
let swipeMoveX = 0;

const getSwipeDirection = e => {
	if ( e.type == 'touchstart' || e.type == 'mousedown' ) {
		swipeStartX = e.touches ? e.touches[0].clientX : e.clientX;
		return 0;
	}
	if ( e.type == 'touchmove' || e.type == 'mousemove' ) {
		swipeMoveX = e.touches ? e.touches[0].clientX : e.clientX;
		return 0;
	}
	if ( e.type == 'touchend' || e.type == 'mouseup' ) {
		let swipeDiff = swipeMoveX > 0 ? Math.abs(swipeStartX - swipeMoveX) : 0;
		return swipeDiff > swipeTreshold ? (swipeMoveX > swipeStartX ? -1 : 1) : 0;
	}
};

const getSearchParamsFromCookie = () => {
    return {dateFrom: getCookie('form_dateFrom') || null, dateTo: getCookie('form_dateTo'), guests: getCookie('form_guests') || null};
}

const setSearchParamsInCookie = (params) => {

    if (params.hasOwnProperty('dateFrom')) setCookie('form_dateFrom', params.dateFrom);
    if (params.hasOwnProperty('dateTo')) setCookie('form_dateTo', params.dateTo);
    if (params.hasOwnProperty('guests')) setCookie('form_guests', params.guests);
}

const getDataForUrl = (data) => {
    $.map(data, (value, key) => !value && (delete data[key]));
    if (data.dates) {
        let dates = data.dates.split(' - ');
        data.dateFrom = dates[0];
        data.dateTo = dates[1];
        delete data.dates;
    }

    return data;

};


export default {
    getFormData: getFormData,
    getUrlData: getUrlData,
    setFormData: setFormData,
    setUrlData: setUrlData,
    getLang: getLang,
    setCookie: setCookie,
    getCookie: getCookie,
    initCompare: initCompare,
    scrollToElement: scrollToElement,
    smallWin: smallWin,
    isObject: isObject,
    isMobile: isMobile,
    getSwipeDirection: getSwipeDirection,
    setSearchParamsInCookie: setSearchParamsInCookie,
    getSearchParamsFromCookie: getSearchParamsFromCookie,
    getDataForUrl: getDataForUrl
};